export const TableKeys = {
    PensionCommencementLumpSumAllocations: "PensionCommencementLumpSumAllocations",
    IncomeDisinvestmentAllocations: "IncomeDisinvestmentAllocations",
};